import { render, staticRenderFns } from "./LazyComponent.vue?vue&type=template&id=f29578b6"
import script from "./LazyComponent.vue?vue&type=script&lang=js"
export * from "./LazyComponent.vue?vue&type=script&lang=js"
import style0 from "@v4/common/components/atoms/LazyComponent/_index.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.44_css-loader@7.1.5_webpack@5.112.2__ejs@3.1.1_ee2c7053b1d68e4067351b3e8f0482a3/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports